var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../self-services.service.ts';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { UploadService } from './upload.service';
var DIComponent = /** @class */ (function () {
    /**
    * @class DIComponent
    * @constructor
    */
    function DIComponent(userService, router, spinnerService, diService, environment, bpgCommonService, uploadService) {
        this.userService = userService;
        this.router = router;
        this.spinnerService = spinnerService;
        this.diService = diService;
        this.environment = environment;
        this.bpgCommonService = bpgCommonService;
        this.uploadService = uploadService;
        this.editandSavebtn = false;
        this.savebtn = false;
        this.adminId = localStorage.getItem('adminId');
        this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
        this.loginUserId = this.loginDetails['userId'];
        this.diMasterTable = true;
        this.diNewsTable = false;
        this.diResourceTable = false;
        this.diReTeamTable = false;
        this.diNaacTable = false;
        this.aboutDesc = "";
        this.isUploadnewsImage = false;
        this.isLoadernewsImageStop = false;
        this.fileTypeConstant = 'JPEG or PNG';
        this.selectedFileNameforNews = this.fileTypeConstant;
        this.newsfileName = '';
        this.newsExtensionError = false;
        this.siteList = [];
        this.siteName = [];
        this.siteNameList = [];
        this.LandingPaginationDTO = new LandingPaginationDTO();
        this.limit = ConstantValues.pageLimit;
        this.currentShowingElementsNews = ConstantValues.pageLimit;
        this.currentShowingElementsResource = ConstantValues.pageLimit;
        this.currentShowingElementsReTeam = ConstantValues.pageLimit;
        this.currentShowingElementsNaac = ConstantValues.pageLimit;
        this.uploadFileExtensionBanner = false;
        this.uploadFileExtensionUser = false;
        this.uploadFileExtensionNaac = false;
        this.uploadImageDone = false;
        this.isLoaderStop = false;
        this.isUploadImage = false;
        this.fileNameList = [];
        this.fileExtensionCount = 0;
        this.deleteSuccess = false;
        this.uploadUserPicImageDone = false;
        this.isLoaderUserPicStop = false;
        this.isUploadUserPicImage = false;
        this.diBannerImage = null;
        this.currentPage = 0;
        this.diUpdateSuccess = false;
        this.diNewsSuccess = false;
        this.diResourceSuccess = false;
        this.diReteamSuccess = false;
        this.diNaacSuccess = false;
        this.noNewsTable = false;
        this.noResourceTable = false;
        this.noReginalTbale = false;
        this.noNaacTable = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.deleteNaac = false;
        this.uploadFileName = null;
        this.uploadFileNameUser = null;
        this.uploadFileNameNaac = null;
        this.diNaacBannerImage = null;
        this.showReset = false;
        this.diUserImage = null;
        this.logoPathImage = null;
        this.errorMessageResourceActive = false;
        this.errorMessageRegionalActive = false;
        this.firstEditNews = true;
        this.firstEditResource = true;
        this.firstEditReTeam = true;
        this.firstEditNaac = true;
        this.saveAndUpdateNews = false;
        this.saveNews = true;
        this.saveResource = true;
        this.saveAndUpdateResource = false;
        this.saveReTeam = true;
        this.saveAndUpdateReTeam = false;
        this.saveNaac = true;
        this.saveAndUpdateNaac = false;
        this.saveMasterBtn = false;
        this.newsLinkValid = false;
        this.naacLinkValid = false;
        this.reTeamEamilValid = false;
        this.ResourcefileName = "Upload document(< 500MB)";
        this.fileSizeExtensionError = false;
        this.selectedFile = null;
        this.isuploaded = true;
        this.fileList = [];
        this.timeOutError = false;
        this.isFileUploded = false;
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.failureOnResourceUpload = false;
        this.butDisabled = true;
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.folderNameList = [];
        //Image Cropper
        this.imageChangedEvent = '';
        this.imageChangedEventBanner = '';
        this.croppedImage = '';
        this.imageTypeName = null;
        this.removeToolbar = { toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat' };
        this.msg1Constant = " Are you sure you want to update ? ";
        this.dataToggleConstant = 'data-toggle';
        this.dataTargetConstant = 'data-target';
        this.msgConstant = " Are you sure you want to Save ? ";
        this.msg2Constant = " Your current changes will be discarded, do you want to continue ? ";
        this.fileType1Constant = "image/jpeg";
    }
    DIComponent.prototype.ngOnInit = function () {
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        localStorage.removeItem('searchedEventsCaledarItems');
        if (this.adminId !== '1') {
            this.router.navigate(['/site-home']);
        }
        this.bpgCommonService.getSessionToken();
        this.saveMasterBtn = true;
        this.diId = '0';
        this.logUserAction();
        this.getDiMasterList();
        this.getdiBannerList();
        this.getallSite();
        this.imageChangedEvent = '';
        this.imageChangedEventBanner = '';
        this.croppedImage = '';
        this.uploadFileName = '';
        this.uploadFileExtensionUser = false;
        document.getElementById("base64textareaUser").textContent = '';
        document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
        this.myInputVariable.nativeElement.value = '';
        document.getElementById("base64textarea").textContent = '';
        document.getElementById("filenameBanner").textContent = this.fileTypeConstant;
        this.myInputBannerVariable.nativeElement.value = '';
        this.isUploadImage = false;
        this.isLoaderStop = false;
        this.diUserImage = null;
        this.uploadImageDone = false;
        this.uploadUserPicImageDone = false;
        this.isLoaderUserPicStop = false;
        this.isLoadernewsImageStop = false;
        this.isUploadUserPicImage = false;
    };
    /** To get Di Master Data
      * @class DIComponent
      * @method getDiMasterList
      */
    DIComponent.prototype.getDiMasterList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO.sortDirection = "ASC";
        this.LandingPaginationDTO.sortProperty = "diName";
        this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" };
        this.diService.getDiMasterList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.diMasterList = data.content;
            _this.spinnerService.hide();
        });
    };
    /** get all site list
     * @class allSite
     * @method   getallSite(){
  
     */
    DIComponent.prototype.getallSite = function () {
        var _this = this;
        this.userService.getAllSite().subscribe(function (data) {
            _this.siteList = data;
        });
    };
    /** get banner image list
     * @class BannerImage
     * @method getdiBannerList
     */
    DIComponent.prototype.getdiBannerList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = 50;
        this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" };
        this.userService.getdiBannerList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.bannerResponseList = data.content;
            _this.deleteSuccess = false;
            _this.spinnerService.hide();
            _this.numberOfElements = data.totalElements;
            if (_this.bannerResponseList.length === 0) {
                _this.noDataFound = true;
            }
            else {
                _this.noDataFound = false;
            }
        });
    };
    /** to clear data
     * @class DIComponent
     * @method clearAlerts
     */
    DIComponent.prototype.clearAlerts = function () {
        this.noUser = false;
        this.userFound = false;
    };
    /** to list users other than admins
    * @class DIComponent
    * @method getUserList
    */
    DIComponent.prototype.getUserList = function () {
        var _this = this;
        this.diReteamSuccess = false;
        this.deleteRegional = false;
        this.LandingPaginationDTO.filter = { "leadershipPosition": "USER" };
        this.diService.getUserDropDown(this.LandingPaginationDTO).subscribe(function (data) {
            _this.userList = data;
            if (_this.userList.length === 0) {
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 500);
                _this.noUser = true;
                _this.userFirstName = null;
                _this.emailId = null;
                _this.butDisabled = true;
            }
            else {
                _this.butDisabled = false;
                if (_this.search) {
                    setTimeout(function () {
                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 500);
                    _this.userFound = true;
                }
                _this.userList.map(function (i) { i.userFirstName = i.userFirstName + " " + i.userLastName; return i; });
            }
        }, function (_err) {
        });
    };
    /** to select the user acc to serach
    * @class DIComponent
    * @method userSelection
    */
    DIComponent.prototype.userSelection = function (user) {
        this.userFound = false;
        for (var _i = 0, _a = this.userList; _i < _a.length; _i++) {
            var use = _a[_i];
            if (use != null) {
                if (user.userId === use.userId) {
                    this.userId = use.userId;
                    this.name = use.userFirstName;
                    this.emailId = use.emailId;
                    this.reTeamEamilValid = false;
                }
            }
        }
    };
    /** to sumbit di master
    * @class DIComponent
    * @method onDiMasterSubmit
    */
    DIComponent.prototype.onDiMasterSubmit = function () {
        if (this.uploadFileExtensionBanner === true) {
            this.removeModal();
            return;
        }
        if (this.saveMasterBtn === true) {
            this.setModal();
            this.popupModal();
            document.getElementById('masterSave').click();
        }
    };
    DIComponent.prototype.popupModal = function () {
        this.method = "saveMaster";
        this.param = '';
        this.msg1 = this.msg1Constant;
    };
    DIComponent.prototype.setModal = function () {
        document.getElementById('masterSave').setAttribute(this.dataToggleConstant, 'modal');
        document.getElementById('masterSave').setAttribute(this.dataTargetConstant, '#myModal');
    };
    DIComponent.prototype.removeModal = function () {
        document.getElementById('masterSave').removeAttribute(this.dataToggleConstant);
        document.getElementById('masterSave').removeAttribute(this.dataTargetConstant);
    };
    /** to delete news Image
       * @class DIComponent
       * @method removeFile
       */
    DIComponent.prototype.removeFile = function () {
        this.diNewsSuccess = false;
        this.newsSearchKey = null;
        this.newsLinkValid = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.selectedFileNameforNews = this.fileTypeConstant;
        this.isUploadnewsImage = false;
        this.newsFile = null;
        this.newsfileName = '';
        this.newsExtensionError = false;
    };
    /** to submit news
    * @class DIComponent
    * @method onNewsSubmit
    */
    DIComponent.prototype.onNewsSubmit = function () {
        if (this.saveAndUpdateNews === true) {
            this.method = "addNews";
            this.param = '';
            this.msg1 = this.msg1Constant;
        }
        else {
            this.method = "addNews";
            this.param = '';
            this.msg1 = this.msgConstant;
        }
    };
    /** to save/update news
    * @class DIComponent
    * @method addNews
    */
    DIComponent.prototype.addNews = function () {
        var _this = this;
        this.spinnerService.show();
        var uploadData = {
            'category': 'uploadDocument',
        };
        if (!this.isUploadnewsImage) {
            this.newsfileName = '';
        }
        var diData = {
            "diNewsTitle": this.newsTitle,
            "diNewsDesc": this.newsDesc,
            "diNewsLink": this.newsLink,
            "id": this.loginDetails.userId,
            "diId": this.diMasterList[0].diId,
            "diNewsId": this.newsId,
            "newsImage": this.newsfileName,
            "imageCheck": this.isUploadnewsImage
        };
        this.diService.diAddNews(diData).subscribe(function (data) {
            if (data !== undefined) {
                _this.deleteNews = false;
                _this.diNewsSuccess = true;
                var newsImageName_1 = data.diNewsName;
                _this.uploadFlag = 'news';
                if (_this.newsFile != null) {
                    _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.awsUrls = data;
                                    return [4 /*yield*/, this.uploadService.getPresignedUrl(this.newsFile, this.awsUrls, newsImageName_1, this.uploadFlag)];
                                case 1:
                                    _a.sent();
                                    if (localStorage.getItem('uploadError') === 'Error') {
                                        this.errorMsgUploadSave = true;
                                    }
                                    else {
                                        this.diNewsSuccess = true;
                                        this.getDiNewsList();
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                else {
                    _this.diNewsSuccess = true;
                    _this.getDiNewsList();
                }
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
                _this.spinnerService.hide();
            }
        });
    };
    /** to submit resource
   * @class DIComponent
   * @method onResourceSubmit
   */
    DIComponent.prototype.onResourceSubmit = function () {
        if (this.saveAndUpdateResource === true) {
            this.method = "addResource";
            this.param = '';
            this.msg1 = this.msg1Constant;
        }
        else {
            this.method = "addResource";
            this.param = '';
            this.msg1 = this.msgConstant;
        }
    };
    /** to submit resource
    * @class DIComponent
    * @method onResourceSubmit
    */
    DIComponent.prototype.onDiMasterSubmitBanner = function () {
        this.method = "addBanner";
        this.param = '';
        this.msg1 = this.msg1Constant;
    };
    DIComponent.prototype.addBanner = function () {
        var _this = this;
        var bannerData = {
            "diId": 0,
            "id": this.loginDetails.userId,
            "diBanner": this.uploadFileName,
            "diBannerImage": this.diBannerImage
        };
        this.diService.diAddMaster(bannerData).subscribe(function (response) {
            if (response.body.message === 'Error') {
                _this.errorMsgUploadSave = true;
            }
            else {
                _this.diUpdateSuccess = true;
                _this.cancelUploadedImage('bannerImage');
                _this.getdiBannerList();
            }
        });
    };
    /** to save/update resource
  * @class DIComponent
  * @method addResource
  */
    DIComponent.prototype.addResource = function () {
        var _this = this;
        this.spinnerService.show();
        var uploadData = {
            'category': 'uploadDocument',
        };
        this.uploadFlag = 'resource';
        var diData = {
            "diResourceTitle": this.addResouceTitle,
            "diResourceDesc": this.additionalDesc,
            "diResourceDocument": this.UploadDocument,
            "id": this.loginDetails.userId,
            "resourceOrder": this.resourceOrder,
            "diId": this.diMasterList[0].diId,
            "diResourceId": this.diResourceId,
            "folderId": this.selectedFolder
        };
        //for edit case
        if (this.saveAndUpdateResource === true) {
            if (this.selectedFile != null) {
                this.spinnerService.show();
                this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.awsUrls = data;
                                return [4 /*yield*/, this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.diResourceId, this.uploadFlag)];
                            case 1:
                                _a.sent();
                                if (localStorage.getItem('uploadError') === 'Error') {
                                    this.errorMessageResourceActive = false;
                                    this.errorMsgUploadSaveUpdate = true;
                                    this.diResourceSuccess = false;
                                    this.getDiResouceList();
                                    this.getDiFolderList();
                                    setTimeout(function () {
                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                    }, 200);
                                    this.spinnerService.hide();
                                    localStorage.removeItem('uploadError');
                                }
                                else {
                                    this.diService.diAddResource(diData).subscribe(function (data) {
                                        _this.resourceData = data;
                                        _this.uploadFlag = 'resource';
                                        if (data.message !== undefined) {
                                            _this.errorMessageResource = data.message;
                                            _this.errorMessageResourceActive = true;
                                            _this.errorMsgUploadSaveUpdate = false;
                                            _this.diResourceSuccess = false;
                                            setTimeout(function () {
                                                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                            }, 200);
                                        }
                                        else if (data !== undefined) {
                                            _this.spinnerService.show();
                                            _this.errorMessageResourceActive = false;
                                            _this.diResourceSuccess = true;
                                            _this.deleteResource = false;
                                            _this.errorMsgUploadSaveUpdate = false;
                                            _this.getDiResouceList();
                                            _this.getDiFolderList();
                                            _this.spinnerService.hide();
                                            setTimeout(function () {
                                                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                            }, 200);
                                        }
                                    });
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
            else {
                //edit no files selected
                this.spinnerService.show();
                this.diService.diAddResource(diData).subscribe(function (data) {
                    if (data.message !== undefined) {
                        _this.errorMessageResource = data.message;
                        _this.errorMessageResourceActive = true;
                        _this.diResourceSuccess = false;
                        _this.spinnerService.hide();
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                    }
                    else if (data !== undefined) {
                        _this.errorMessageResourceActive = false;
                        _this.diResourceSuccess = true;
                        _this.deleteResource = false;
                        _this.getDiResouceList();
                        _this.getDiFolderList();
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                        _this.spinnerService.hide();
                    }
                });
            }
        }
        //if save condition
        else {
            this.spinnerService.show();
            this.diService.diAddResource(diData).subscribe(function (data) {
                _this.resourceData = data;
                if (data.message !== undefined) {
                    _this.errorMessageResource = data.message;
                    _this.errorMessageResourceActive = true;
                    _this.diResourceSuccess = false;
                    _this.deleteResource = false;
                    _this.spinnerService.hide();
                    setTimeout(function () {
                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                    }, 300);
                }
                else if (data !== undefined) {
                    _this.spinnerService.show();
                    _this.uploadFlag = 'resource';
                    if (_this.selectedFile != null) {
                        _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var dleteData;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.awsUrls = data;
                                        return [4 /*yield*/, this.uploadService.getPresignedUrl(this.selectedFile, this.awsUrls, this.resourceData.diResourceId, this.uploadFlag)];
                                    case 1:
                                        _a.sent();
                                        if (localStorage.getItem('uploadError') === 'Error') {
                                            dleteData = {
                                                "id": this.resourceData.diResourceId,
                                                "flag": "resource"
                                            };
                                            this.diService.deleteDi(dleteData).subscribe(function (data) {
                                                if (data.flag === "resource") {
                                                    _this.errorMessageResourceActive = false;
                                                    _this.errorMsgUploadSave = true;
                                                    _this.diResourceSuccess = false;
                                                    _this.getDiResouceList();
                                                    _this.getDiFolderList();
                                                    setTimeout(function () {
                                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                                    }, 200);
                                                }
                                            });
                                            this.spinnerService.hide();
                                            localStorage.removeItem('uploadError');
                                        }
                                        else {
                                            this.errorMessageResourceActive = false;
                                            this.diResourceSuccess = true;
                                            this.deleteResource = false;
                                            this.errorMsgUploadSave = false;
                                            this.getDiResouceList();
                                            this.getDiFolderList();
                                            setTimeout(function () {
                                                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                            }, 200);
                                        }
                                        this.spinnerService.hide();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                }
            });
        }
    };
    /** to submit ReTeam
   * @class DIComponent
   * @method onReTeamSubmit
   */
    DIComponent.prototype.onReTeamSubmit = function () {
        if (this.uploadFileExtensionUser === true) {
            this.removeModalReTeam();
            return;
        }
        if (this.saveAndUpdateReTeam === true) {
            this.setModalReTeam();
            this.popupModalReTeam();
            document.getElementById('UpdateReTeam').click();
        }
        else {
            this.setModalReTeam();
            this.popupModalReTeam();
            document.getElementById('saveReTeam').click();
        }
    };
    DIComponent.prototype.popupModalReTeam = function () {
        if (this.saveAndUpdateReTeam === true) {
            this.method = "addReTeam";
            this.param = '';
            this.msg1 = this.msg1Constant;
        }
        else {
            this.method = "addReTeam";
            this.param = '';
            this.msg1 = this.msgConstant;
        }
    };
    DIComponent.prototype.setModalReTeam = function () {
        if (this.saveAndUpdateReTeam === true) {
            document.getElementById('UpdateReTeam').setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('UpdateReTeam').setAttribute(this.dataTargetConstant, '#myModal');
        }
        else {
            document.getElementById('saveReTeam').setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('saveReTeam').setAttribute(this.dataTargetConstant, '#myModal');
        }
    };
    DIComponent.prototype.removeModalReTeam = function () {
        if (this.saveAndUpdateReTeam === true) {
            document.getElementById('UpdateReTeam').removeAttribute(this.dataToggleConstant);
            document.getElementById('UpdateReTeam').removeAttribute(this.dataTargetConstant);
        }
        else {
            document.getElementById('saveReTeam').removeAttribute(this.dataToggleConstant);
            document.getElementById('saveReTeam').removeAttribute(this.dataTargetConstant);
        }
    };
    /** to save/edit reTeam
   * @class DIComponent
   * @method addReTeam
   */
    DIComponent.prototype.addReTeam = function () {
        var _this = this;
        if (this.saveAndUpdateReTeam === true) {
            this.reTeamFlag = "updateReTeam";
        }
        else {
            this.reTeamFlag = "saveReTeam";
        }
        this.siteNameList = [];
        if (this.siteName.length > 0) {
            for (var _i = 0, _a = this.siteName; _i < _a.length; _i++) {
                var site = _a[_i];
                if (site.siteName != null && site.siteName !== undefined) {
                    this.siteNameList.push(site.siteName);
                }
                else {
                    this.siteNameList.push(site);
                }
            }
        }
        this.spinnerService.show();
        this.diUserImage = document.getElementById("base64textareaUser").textContent;
        var diData = {
            "userId": this.userId,
            "roleName": this.regionalDesignation,
            "emailId": this.emailId,
            "userPic": this.uploadFileNameUser,
            "id": this.loginDetails.userId,
            "regionalOrder": this.reTeamOrder,
            "diId": this.diMasterList[0].diId,
            "reTeamPic": this.diUserImage,
            "diReTeamId": this.diReTeamId,
            "reTeamFlag": this.reTeamFlag,
            "diPronounce": this.diPronoun,
            "siteNameList": this.siteNameList
        };
        this.diService.diReTeamAdd(diData).subscribe(function (data) {
            if (data.message !== undefined) {
                _this.errorMessageRegional = data.message;
                _this.errorMessageRegionalActive = true;
                _this.diReteamSuccess = false;
                _this.noUser = false;
                _this.userFound = false;
            }
            else if (data !== undefined) {
                _this.errorMessageRegionalActive = false;
                _this.noUser = false;
                _this.userFound = false;
                _this.diReteamSuccess = true;
                _this.deleteRegional = false;
                _this.LandingPaginationDTO.searchTerm = '';
                _this.getReteamList();
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    /** to sumbit naac
   * @class DIComponent
   * @method onNaacSubmit
   */
    DIComponent.prototype.onNaacSubmit = function () {
        if (this.uploadFileExtensionNaac === true) {
            this.removeModalNaac();
            return;
        }
        if (this.saveAndUpdateNaac === true) {
            this.setModalReTeamNaac();
            this.popupModalReTeamNaac();
            document.getElementById('UpdateNac').click();
        }
        else {
            this.setModalReTeamNaac();
            this.popupModalReTeamNaac();
            document.getElementById('saveNaac').click();
        }
    };
    DIComponent.prototype.popupModalReTeamNaac = function () {
        if (this.saveAndUpdateNaac === true) {
            this.method = "addNaac";
            this.param = '';
            this.msg1 = this.msg1Constant;
        }
        else {
            this.method = "addNaac";
            this.param = '';
            this.msg1 = " Are you sure you want to save ? ";
        }
    };
    DIComponent.prototype.setModalReTeamNaac = function () {
        if (this.saveAndUpdateNaac === true) {
            document.getElementById('UpdateNac').setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('UpdateNac').setAttribute(this.dataTargetConstant, '#myModal');
        }
        else {
            document.getElementById('saveNaac').setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('saveNaac').setAttribute(this.dataTargetConstant, '#myModal');
        }
    };
    DIComponent.prototype.removeModalNaac = function () {
        if (this.saveAndUpdateNaac === true) {
            document.getElementById('UpdateNac').removeAttribute(this.dataToggleConstant);
            document.getElementById('UpdateNac').removeAttribute(this.dataTargetConstant);
        }
        else {
            document.getElementById('saveNaac').removeAttribute(this.dataToggleConstant);
            document.getElementById('saveNaac').removeAttribute(this.dataTargetConstant);
        }
    };
    /** to save/edit naac
   * @class DIComponent
   * @method addNaac
   */
    DIComponent.prototype.addNaac = function () {
        var _this = this;
        if (this.saveAndUpdateNaac === true) {
            this.naacFlag = "saveNaac";
        }
        else {
            this.naacFlag = "updateNaac";
        }
        this.spinnerService.show();
        this.logoPathImage = document.getElementById("base64textareaNaac").textContent;
        var diData = {
            "diId": this.diMasterList[0].diId,
            "id": this.loginDetails.userId,
            "naacAffiliateName": this.naacName,
            "logoPath": this.uploadFileNameNaac,
            "sharepointLink": this.naacLink,
            "naacAffiliateId": this.naacId,
            "logoPathImage": this.logoPathImage,
            "naacFlag": this.naacFlag,
        };
        this.diService.diNaacAdd(diData).subscribe(function (data) {
            if (data !== undefined) {
                _this.diNaacSuccess = true;
                _this.deleteNaac = false;
                _this.getNaacList();
            }
            setTimeout(function () {
                window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            _this.spinnerService.hide();
        });
    };
    /** to reset news
     * @class DIComponent
     * @method resetNews
     */
    DIComponent.prototype.resetNews = function () {
        this.clearAlerts();
        this.method = "onResetNewsClick";
        this.param = '';
        this.msg1 = this.msg2Constant;
    };
    DIComponent.prototype.onResetNewsClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteNews = false;
        this.deleteResetNews();
        this.getDiNewsList();
    };
    DIComponent.prototype.deleteResetNews = function () {
        this.diNewsSuccess = false;
        this.newsId = null;
        this.newsTitle = null;
        this.newsDesc = null;
        this.newsLink = null;
        this.newsSearchKey = null;
        this.saveNews = true;
        this.firstEditNews = true;
        this.saveAndUpdateNews = false;
        this.newsLinkValid = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.selectedFileNameforNews = this.fileTypeConstant;
        this.isUploadnewsImage = false;
        this.newsFile = null;
        this.newsfileName = '';
        this.newsExtensionError = false;
    };
    /** to reset resource
     * @class DIComponent
     * @method resetResource
     */
    DIComponent.prototype.resetResource = function () {
        this.clearAlerts();
        this.method = "onResetResourceClick";
        this.param = '';
        this.msg1 = this.msg2Constant;
    };
    DIComponent.prototype.onResetResourceClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteResource = false;
        this.deleteResetResource();
        this.getDiResouceList();
        this.getDiFolderList();
    };
    DIComponent.prototype.deleteResetResource = function () {
        this.addResouceTitle = null;
        this.additionalDesc = null;
        this.addResourceDocument = null;
        this.resourceOrder = null;
        this.resourceSearchKey = null;
        this.LandingPaginationDTO.searchTerm = '';
        this.diResourceSuccess = false;
        this.diResourceId = '0';
        this.saveAndUpdateResource = false;
        this.saveResource = true;
        this.errorMessageResourceActive = false;
        this.ResourcefileName = "Upload document(< 500MB)";
        this.isFileUploded = false;
        this.selectedFile = null;
        this.fileSizeExtensionError = false;
        this.UploadDocument = null;
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.selectedFolder = null;
        this.folderName = '';
        this.folderId = null;
    };
    /** to reset reTeam
     * @class DIComponent
     * @method resetReTeam
     */
    DIComponent.prototype.resetReTeam = function () {
        this.clearAlerts();
        this.method = "onResetReTeamClick";
        this.param = '';
        this.msg1 = this.msg2Constant;
    };
    DIComponent.prototype.onResetReTeamClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteRegional = false;
        this.myInputVariable.nativeElement.value = "";
        this.deleteResetReTeam();
        this.getReteamList();
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this.uploadFileName = '';
        this.uploadFileExtensionUser = false;
        document.getElementById("base64textareaUser").textContent = '';
        document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
        this.myInputVariable.nativeElement.value = '';
        this.isUploadImage = false;
        this.isLoaderStop = false;
        this.diUserImage = null;
    };
    DIComponent.prototype.deleteResetReTeam = function () {
        this.userList = null;
        this.regionalDesignation = null;
        this.userId = null;
        this.userFirstName = null;
        this.searchTerm = null;
        this.emailId = null;
        this.userPic = null;
        this.reTeamOrder = null;
        this.reTeamSearchKey = null;
        this.LandingPaginationDTO.searchTerm = '';
        this.diReteamSuccess = false;
        this.diUserImage = null;
        this.diReTeamId = '0';
        this.reTeamEamilValid = false;
        this.uploadFileExtensionUser = false;
        this.errorMessageRegionalActive = false;
        this.diPronoun = '';
        if (this.lbl !== undefined) {
            this.lbl.innerText = "JPEG or PNG (400 x 200)";
        }
        document.getElementById("base64textareaUser").textContent = '';
        document.getElementById("filenameUserPic").textContent = "JPEG or PNG (400 x 200)";
        this.saveReTeam = true;
        this.saveAndUpdateReTeam = false;
        this.butDisabled = true;
    };
    /** to reset naac
    * @class DIComponent
    * @method resetNaac
    */
    DIComponent.prototype.resetNaac = function () {
        this.clearAlerts();
        this.method = "onResetNaacClick";
        this.param = '';
        this.msg1 = this.msg2Constant;
    };
    DIComponent.prototype.onResetNaacClick = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.deleteNaac = false;
        this.deleteResetNaac();
        this.getNaacList();
    };
    DIComponent.prototype.deleteResetNaac = function () {
        this.naacName = null;
        this.naacLogo = null;
        this.naacLink = null;
        this.LandingPaginationDTO.searchTerm = '';
        this.naacSearchKey = null;
        this.diNaacSuccess = false;
        this.naacLinkValid = false;
        this.saveNaac = true;
        this.saveAndUpdateNaac = false;
        this.uploadFileExtensionNaac = false;
        if (this.lbl !== undefined) {
            this.lbl.innerText = "JPEG or PNG (80 x 60)";
        }
        document.getElementById("base64textareaNaac").textContent = '';
        document.getElementById("filenameNaac").textContent = "JPEG or PNG (80 x 60)";
    };
    /** action on click of di master tab
    * @class DIComponent
    * @method diMaster
    */
    DIComponent.prototype.diMaster = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.diMasterTable = true;
        this.diNewsTable = false;
        this.diResourceTable = false;
        this.diReTeamTable = false;
        this.diNaacTable = false;
        this.noNewsTable = false;
        this.noResourceTable = false;
        this.noReginalTbale = false;
        this.noNaacTable = false;
        this.diNewsSuccess = false;
        this.diResourceSuccess = false;
        this.diReteamSuccess = false;
        this.diNaacSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.deleteNaac = false;
        this.errorMessageResourceActive = false;
        this.errorMessageRegionalActive = false;
        this.userFound = false;
        this.noUser = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.naacSearchKey = '';
        this.searchTerm = '';
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
    };
    /** action on click of di news tab
   * @class DIComponent
   * @method diMaster
   */
    DIComponent.prototype.diNews = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.diNewsTable = true;
        this.diMasterTable = false;
        this.diResourceTable = false;
        this.diReTeamTable = false;
        this.diNaacTable = false;
        this.noResourceTable = false;
        this.noReginalTbale = false;
        this.noNaacTable = false;
        this.diUpdateSuccess = false;
        this.diNewsSuccess = false;
        this.diUpdateSuccess = false;
        this.diReteamSuccess = false;
        this.diNaacSuccess = false;
        this.diResourceSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.deleteNaac = false;
        this.userFound = false;
        this.noUser = false;
        this.errorMessageResourceActive = false;
        this.errorMessageRegionalActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.naacSearchKey = '';
        this.searchTerm = '';
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.getDiNewsList();
    };
    /** get list of di news
    * @class DIComponent
    * @method getDiNewsList
    */
    DIComponent.prototype.getDiNewsList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO.sortDirection = "DESC";
        this.LandingPaginationDTO.sortProperty = "modifiedDateTime";
        this.diService.getDiNewsList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.diNewsList = data.content;
            if (_this.diNewsList.length === 0) {
                _this.noNewsTable = true;
            }
            else {
                _this.noNewsTable = false;
                _this.tableShow = true;
            }
            _this.numberOfElements = data.totalElements;
            _this.spinnerService.hide();
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsNews = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsNews = _this.numberOfElements;
            }
        });
    };
    /** action on click of di resource tab
    * @class DIComponent
    * @method diResource
    */
    DIComponent.prototype.diResource = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.diNewsTable = false;
        this.diMasterTable = false;
        this.diResourceTable = true;
        this.diReTeamTable = false;
        this.diNaacTable = false;
        this.noNewsTable = false;
        this.noReginalTbale = false;
        this.noNaacTable = false;
        this.diUpdateSuccess = false;
        this.diNewsSuccess = false;
        this.diUpdateSuccess = false;
        this.diReteamSuccess = false;
        this.diNaacSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.deleteNaac = false;
        this.userFound = false;
        this.noUser = false;
        this.errorMessageRegionalActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.naacSearchKey = '';
        this.searchTerm = '';
        this.getDiResouceList();
        this.getDiFolderList();
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
    };
    /** get list of di resource
    * @class DIComponent
    * @method getDiResouceList
    */
    DIComponent.prototype.getDiResouceList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO.sortDirection = "ASC";
        this.LandingPaginationDTO.sortProperty = "folderOrder";
        this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" };
        this.diService.getDiResouceList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.diResouceList = data.content;
            if (_this.diResouceList.length === 0) {
                _this.noResourceTable = true;
            }
            else {
                _this.noResourceTable = false;
                _this.tableShow = true;
            }
            _this.numberOfElements = data.totalElements;
            _this.spinnerService.hide();
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsResource = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsResource = _this.numberOfElements;
            }
        });
    };
    /** get list of di Folders
  * @class DIComponent
  * @method getDiFolderList
  */
    DIComponent.prototype.getDiFolderList = function () {
        var _this = this;
        this.landingData = {
            "filter": {},
            "moduleId": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 50,
            "sortDirection": "DESC",
            "sortProperty": "created_date_time",
            "uid": ""
        };
        this.userService.getDiDocumentsFolder(this.landingData).subscribe(function (data) {
            _this.folderNameList = data.content;
        });
    };
    /** action on click of di reTeam tab
    * @class DIComponent
    * @method diReTeam
    */
    DIComponent.prototype.diReTeam = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.diNewsTable = false;
        this.diMasterTable = false;
        this.diResourceTable = false;
        this.diReTeamTable = true;
        this.diNaacTable = false;
        this.noResourceTable = false;
        this.noNewsTable = false;
        this.noNaacTable = false;
        this.noReginalTbale = false;
        this.diUpdateSuccess = false;
        this.diNewsSuccess = false;
        this.diReteamSuccess = false;
        this.diNaacSuccess = false;
        this.diResourceSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.deleteNaac = false;
        this.errorMessageResourceActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.naacSearchKey = '';
        this.searchTerm = '';
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.getReteamList();
    };
    /** get list of di Reteam
     * @class DIComponent
     * @method getReteamList
     */
    DIComponent.prototype.getReteamList = function () {
        var _this = this;
        if (this.searchTerm != null && (this.reTeamSearchKey === null || this.reTeamSearchKey === '')) {
            this.LandingPaginationDTO.searchTerm = '';
        }
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO.sortDirection = "ASC";
        this.LandingPaginationDTO.sortProperty = "regionalOrder";
        this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" };
        this.diService.getReteamList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.diReTeamList = data.content;
            if (_this.diReTeamList.length === 0) {
                _this.noReginalTbale = true;
                _this.tableShow = true;
            }
            else {
                _this.noReginalTbale = false;
            }
            _this.numberOfElements = data.totalElements;
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsReTeam = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsReTeam = _this.numberOfElements;
            }
        });
        this.spinnerService.hide();
    };
    /** action on click of di naac tab
    * @class DIComponent
    * @method diNaac
    */
    DIComponent.prototype.diNaac = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.currentPage = 1;
        this.LandingPaginationDTO.page = 0;
        this.diNewsTable = false;
        this.diMasterTable = false;
        this.diResourceTable = false;
        this.diReTeamTable = false;
        this.diNaacTable = true;
        this.noNewsTable = false;
        this.noResourceTable = false;
        this.noReginalTbale = false;
        this.diUpdateSuccess = false;
        this.diNewsSuccess = false;
        this.diReteamSuccess = false;
        this.diNaacSuccess = false;
        this.diResourceSuccess = false;
        this.deleteNews = false;
        this.deleteResource = false;
        this.deleteRegional = false;
        this.deleteNaac = false;
        this.errorMessageResourceActive = false;
        this.errorMessageRegionalActive = false;
        this.LandingPaginationDTO.searchTerm = '';
        this.newsSearchKey = '';
        this.resourceSearchKey = '';
        this.reTeamSearchKey = '';
        this.naacSearchKey = '';
        this.searchTerm = '';
        this.userFound = false;
        this.noUser = false;
        this.errorMsgUploadSave = false;
        this.errorMsgUploadSaveUpdate = false;
        this.getNaacList();
    };
    /** get list of di naac
    * @class DIComponent
    * @method getNaacList
    */
    DIComponent.prototype.getNaacList = function () {
        var _this = this;
        this.spinnerService.show();
        this.LandingPaginationDTO.size = ConstantValues.pageLimit;
        this.LandingPaginationDTO.sortDirection = "ASC";
        this.LandingPaginationDTO.sortProperty = "naacAffiliateName";
        this.LandingPaginationDTO.filter = { "diFlag": "diSelfService" };
        this.diService.getNaacList(this.LandingPaginationDTO).subscribe(function (data) {
            _this.naacAffiliateList = data.content;
            if (_this.naacAffiliateList.length === 0) {
                _this.noNaacTable = true;
                _this.tableShow = true;
            }
            else {
                _this.noNaacTable = false;
            }
            _this.numberOfElements = data.totalElements;
            _this.spinnerService.hide();
            if ((_this.currentPage * _this.limit) < _this.numberOfElements) {
                _this.currentShowingElementsNaac = _this.currentPage * _this.limit;
            }
            else if ((_this.currentPage * _this.limit) >= _this.numberOfElements) {
                _this.currentShowingElementsNaac = _this.numberOfElements;
            }
        });
    };
    /** to select the banner image
    * @class DIComponent
    * @method onDiBannerSelected
    */
    DIComponent.prototype.onDiBannerSelected = function (event) {
        var _this = this;
        var files = event.target.files;
        var file = files[0];
        this.uploadFileName = file.name;
        if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
            this.uploadFileExtensionBanner = true;
        }
        else {
            this.uploadFileExtensionBanner = false;
        }
        var image = event.target.files[0];
        var fr = new FileReader();
        fr.onload = function () {
            var img = new Image();
            img.onload = function () {
                _this.width = img.width;
                _this.height = img.height;
                if (_this.width < 1366) {
                    _this.uploadFileExtensionBanner = true;
                }
                else {
                    _this.uploadFileExtensionBanner = false;
                }
            };
            img.src = fr.result; // This is the data URL
        };
        fr.readAsDataURL(image);
        this.lbl2 = document.getElementById('filenameBanner');
        this.lbl2.innerText = this.uploadFileName;
        if (files && file) {
            this.diNaacBannerImage = "";
            var imageData_1 = '';
            var reader = new FileReader();
            if (reader.readAsBinaryString) {
                reader.onloadend = function (readerEvt) {
                    var binaryString = readerEvt.target.result;
                    imageData_1 = btoa(binaryString);
                    document.getElementById("base64textarea").textContent = imageData_1;
                };
                this.diNaacBannerImage = imageData_1;
                reader.readAsBinaryString(file);
            }
            else { //IE 10 or 11
                var binary_1 = "";
                reader.onload = function (e) {
                    var bytes = new Uint8Array(e.target.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary_1 += String.fromCharCode(bytes[i]);
                    }
                    //binary - readonly so assign content to another property
                    imageData_1 = btoa(binary_1);
                    document.getElementById("base64textarea").textContent = imageData_1;
                };
                this.diNaacBannerImage = imageData_1;
                reader.readAsArrayBuffer(file);
            }
        }
    };
    DIComponent.prototype.findbyEmail = function (e) {
        var text = e.target.value;
        if (text.length > 2) {
            this.searchTerm = text;
            this.searchBy();
        }
        else {
            this.userList = [];
        }
    };
    /** to select the user pic
     * @class DIComponent
     * @method onUserPicSelected
     */
    DIComponent.prototype.onUserPicSelected = function (event) {
        var _this = this;
        var files = event.target.files;
        var file = files[0];
        this.uploadFileNameUser = file.name;
        if (this.width === 400 && this.height === 400) {
            this.uploadFileExtensionUser = false;
        }
        else {
            this.uploadFileExtensionUser = true;
        }
        var image = event.target.files[0];
        var fr = new FileReader();
        fr.onload = function () {
            var img = new Image();
            img.onload = function () {
                _this.width = img.width;
                _this.height = img.height;
                if (_this.width === 400 && _this.height === 400) {
                    _this.uploadFileExtensionUser = false;
                }
                else {
                    _this.uploadFileExtensionUser = true;
                }
            };
            img.src = fr.result; // This is the data URL
        };
        fr.readAsDataURL(image);
        this.lbl = document.getElementById('filenameUserPic');
        this.lbl.innerText = this.uploadFileNameUser;
        if (files && file) {
            this.diUserImage = "";
            var imageData_2 = '';
            var reader = new FileReader();
            if (reader.readAsBinaryString) {
                reader.onloadend = function (readerEvt) {
                    var binaryString = readerEvt.target.result;
                    imageData_2 = btoa(binaryString);
                    document.getElementById("base64textareaUser").textContent = imageData_2;
                };
                this.diUserImage = imageData_2;
                reader.readAsBinaryString(file);
            }
            else { //IE 10 or 11
                var binary_2 = "";
                reader.onload = function (e) {
                    var bytes = new Uint8Array(e.target.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary_2 += String.fromCharCode(bytes[i]);
                    }
                    //binary - readonly so assign content to another property
                    imageData_2 = btoa(binary_2);
                    document.getElementById("base64textareaUser").textContent = imageData_2;
                };
                this.diUserImage = imageData_2;
                reader.readAsArrayBuffer(file);
            }
        }
    };
    /** to select the naac logo
      * @class DIComponent
      * @method onNaacSelected
      */
    DIComponent.prototype.onNaacSelected = function (event) {
        var _this = this;
        var files = event.target.files;
        var file = files[0];
        this.uploadFileNameNaac = file.name;
        if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
            this.uploadFileExtensionNaac = true;
        }
        else {
            this.uploadFileExtensionNaac = false;
        }
        var image = event.target.files[0];
        var fr = new FileReader();
        fr.onload = function () {
            var img = new Image();
            img.onload = function () {
                _this.width = img.width;
                _this.height = img.height;
                if (_this.width > 80) {
                    _this.uploadFileExtensionNaac = true;
                }
                else {
                    _this.uploadFileExtensionNaac = false;
                }
            };
            img.src = fr.result; // This is the data URL
        };
        fr.readAsDataURL(image);
        this.lbl = document.getElementById('filenameNaac');
        this.lbl.innerText = this.uploadFileNameNaac;
        if (files && file) {
            this.logoPathImage = "";
            var imageData_3 = '';
            var reader = new FileReader();
            if (reader.readAsBinaryString) {
                reader.onloadend = function (readerEvt) {
                    var binaryString = readerEvt.target.result;
                    imageData_3 = btoa(binaryString);
                    document.getElementById("base64textareaNaac").textContent = imageData_3;
                };
                this.logoPathImage = imageData_3;
                reader.readAsBinaryString(file);
            }
            else { //IE 10 or 11
                var binary_3 = "";
                reader.onload = function (e) {
                    var bytes = new Uint8Array(e.target.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary_3 += String.fromCharCode(bytes[i]);
                    }
                    //binary - readonly so assign content to another property
                    imageData_3 = btoa(binary_3);
                    document.getElementById("base64textareaNaac").textContent = imageData_3;
                };
                this.logoPathImage = imageData_3;
                reader.readAsArrayBuffer(file);
            }
        }
    };
    /** on news page changed
      * @class DIComponent
      * @method onNaacSelected
      */
    DIComponent.prototype.pageNewsChanged = function (event) {
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsNews = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsNews = this.numberOfElements;
        }
        this.getDiNewsList();
    };
    /** on resource page changed
    * @class DIComponent
    * @method pageResourceChanged
    */
    DIComponent.prototype.pageResourceChanged = function (event) {
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsResource = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsResource = this.numberOfElements;
        }
        this.getDiResouceList();
        this.getDiFolderList();
    };
    /** on reTeam page changed
   * @class DIComponent
   * @method pageReteamChanged
   */
    DIComponent.prototype.pageReteamChanged = function (event) {
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsReTeam = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsReTeam = this.numberOfElements;
        }
        this.getReteamList();
    };
    /** on naac page changed
   * @class DIComponent
   * @method pageNaacChanged
   */
    DIComponent.prototype.pageNaacChanged = function (event) {
        this.LandingPaginationDTO.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElementsNaac = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElementsNaac = this.numberOfElements;
        }
        this.getNaacList();
    };
    /** For searching the user
   * @class DIComponent
   * @method searchBy
   */
    DIComponent.prototype.searchBy = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.search = true;
        this.searchTerm = (this.searchTerm) ? this.searchTerm : '';
        this.LandingPaginationDTO.searchTerm = this.searchTerm;
        this.getUserList();
        this.spinnerService.hide();
    };
    /** For searching the news
   * @class DIComponent
   * @method searchNewsMe
   */
    DIComponent.prototype.searchNewsMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.newsSearchKey = (this.newsSearchKey) ? this.newsSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.newsSearchKey;
        this.currentPage = 1;
        this.getDiNewsList();
        this.spinnerService.hide();
    };
    /** For searching the resource
   * @class DIComponent
   * @method searchResourceMe
   */
    DIComponent.prototype.searchResourceMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.resourceSearchKey = (this.resourceSearchKey) ? this.resourceSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.resourceSearchKey;
        this.currentPage = 1;
        this.getDiResouceList();
        this.getDiFolderList();
        this.spinnerService.hide();
    };
    /** For searching the reTeam
   * @class DIComponent
   * @method searchReTeamMe
   */
    DIComponent.prototype.searchReTeamMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.reTeamSearchKey = (this.reTeamSearchKey) ? this.reTeamSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.reTeamSearchKey;
        this.currentPage = 1;
        this.getReteamList();
        this.spinnerService.hide();
    };
    /** For searching the Naac
   * @class DIComponent
   * @method searchNaacMe
   */
    DIComponent.prototype.searchNaacMe = function () {
        this.clearAlerts();
        this.spinnerService.show();
        this.naacSearchKey = (this.naacSearchKey) ? this.naacSearchKey : '';
        this.LandingPaginationDTO.page = 0;
        this.LandingPaginationDTO.searchTerm = this.naacSearchKey;
        this.currentPage = 1;
        this.getNaacList();
        this.spinnerService.hide();
    };
    /** to Delete di
  * @class DIComponent
  * @method deleteDi
  */
    DIComponent.prototype.deleteDi = function (id, flag, i) {
        document.getElementById('deleteDi' + i).setAttribute(this.dataToggleConstant, 'modal');
        document.getElementById('deleteDi' + i).setAttribute(this.dataTargetConstant, '#myModal');
        this.method = "deleteAllDi";
        this.param = id;
        this.param1 = flag;
        this.msg1 = "  Are you sure you want to delete ? ";
    };
    /** to Delete gallery
  * @class ConfigureGalleryComponent
  * @method deleteGallery
  */
    DIComponent.prototype.deleteBanner = function (id) {
        var _this = this;
        this.spinnerService.show();
        this.userService.deleteBannerList(id).subscribe(function (_data) {
            _this.spinnerService.hide();
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            _this.deleteSuccess = true;
            _this.diUpdateSuccess = false;
            _this.getdiBannerList();
        });
    };
    /** confirmation to delete gallery
   * @class deleteBannerConfirmation
   * @method deleteBannerConfirmation
   */
    DIComponent.prototype.deleteBannerConfirmation = function (id) {
        this.method = "deleteBanner";
        this.param = id;
        this.msg1 = "  Are you sure you want to delete ? ";
    };
    DIComponent.prototype.deleteAllDi = function (id, flag) {
        var _this = this;
        var dleteData = {
            "id": id,
            "flag": flag
        };
        this.diService.deleteDi(dleteData).subscribe(function (data) {
            if (data.flag === "news") {
                _this.deleteNews = true;
                _this.deleteResetNews();
                _this.getDiNewsList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
            else if (data.flag === "resource") {
                _this.deleteResource = true;
                _this.deleteResetResource();
                _this.getDiResouceList();
                _this.getDiFolderList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
            else if (data.flag === "regional") {
                _this.deleteRegional = true;
                _this.deleteResetReTeam();
                _this.getReteamList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
            else {
                _this.deleteNaac = true;
                _this.deleteResetNaac();
                _this.getNaacList();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 200);
            }
        });
    };
    /** to edit news
  * @class DIComponent
  * @method editNews
  */
    DIComponent.prototype.editNews = function (data, i) {
        if (this.newsTitle != null || this.newsLink != null) {
            this.firstEditNews = false;
        }
        if (this.firstEditNews === true) {
            this.firstEditNews = false;
            this.editNewsData(data);
        }
        else {
            document.getElementById('editN' + i).setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('editN' + i).setAttribute(this.dataTargetConstant, '#myModal');
            this.method = "editNewsData";
            this.param = data;
            this.msg1 = this.msg2Constant;
        }
    };
    DIComponent.prototype.editNewsData = function (data) {
        this.newsTitle = data.diNewsTitle;
        this.newsDesc = data.diNewsDesc;
        this.newsLink = data.diNewsLink;
        this.newsId = data.diNewsId;
        this.isUploadnewsImage = data.imageCheck;
        this.deleteNews = false;
        this.newsExtensionError = false;
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveNews = false;
        this.saveAndUpdateNews = true;
        this.diNewsSuccess = false;
        this.selectedFileNameforNews = data.diNewsName.length > 13 ? data.diNewsName.substring(13) : this.fileTypeConstant;
        if (!this.isUploadnewsImage) {
            this.selectedFileNameforNews = this.fileTypeConstant;
        }
    };
    /** to edit resource
    * @class DIComponent
    * @method editResource
    */
    DIComponent.prototype.editResource = function (data, i) {
        if (this.addResouceTitle != null || this.addResourceDocument != null) {
            this.firstEditResource = false;
        }
        if (this.firstEditResource === true) {
            this.firstEditResource = false;
            this.editResourceData(data);
        }
        else {
            document.getElementById('editR' + i).setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('editR' + i).setAttribute(this.dataTargetConstant, '#myModal');
            this.method = "editResourceData";
            this.param = data;
            this.msg1 = this.msg2Constant;
        }
    };
    DIComponent.prototype.editResourceData = function (data) {
        this.errorMsgUploadSaveUpdate = false;
        this.errorMsgUploadSave = false;
        this.isFileUploded = true;
        this.addResouceTitle = data.diResourceTitle;
        this.additionalDesc = data.diResourceDesc;
        this.ResourcefileName = data.diResourceDocument;
        this.resourceOrder = data.resourceOrder;
        this.diResourceId = data.diResourceId;
        this.selectedFile = null;
        this.UploadDocument = data.diResourceDocument;
        this.selectedFolder = data.folderId;
        this.folderName = data.folderName;
        this.folderId = data.folderId;
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveResource = false;
        this.saveAndUpdateResource = true;
        this.diResourceSuccess = false;
    };
    /** to edit reTeam
    * @class DIComponent
    * @method editReTeam
    */
    DIComponent.prototype.editReTeam = function (data, i) {
        if (this.regionalDesignation != null || this.emailId != null) {
            this.firstEditReTeam = false;
        }
        if (this.firstEditReTeam === true) {
            this.firstEditReTeam = false;
            this.editReTeamData(data);
        }
        else {
            document.getElementById('editRt' + i).setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('editRt' + i).setAttribute(this.dataTargetConstant, '#myModal');
            this.method = "editReTeamData";
            this.param = data;
            this.msg1 = this.msg2Constant;
        }
    };
    DIComponent.prototype.editReTeamData = function (data) {
        this.butDisabled = false;
        this.noUser = false;
        this.userFound = false;
        this.showReset = true;
        this.searchTerm = null;
        this.RePic = document.getElementById('filenameUserPic');
        this.uploadFileNameUser = data.userPic;
        if (this.uploadFileNameUser != null && this.uploadFileNameUser !== undefined && this.uploadFileNameUser.trim() !== "") {
            var b = this.uploadFileNameUser;
            this.RePic.innerText = b;
        }
        this.diUserImage = '';
        this.userFirstName = data.userName;
        this.regionalDesignation = data.roleName;
        this.emailId = data.emailId;
        this.userPic = data.userPic;
        this.reTeamOrder = data.regionalOrder;
        this.diReTeamId = data.diReTeamId;
        this.userId = data.userId;
        this.diPronoun = data.diPronounce;
        this.siteName = '';
        if (data.siteName.length > 0) {
            this.siteName = data.siteNameList;
        }
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveReTeam = false;
        this.saveAndUpdateReTeam = true;
        this.diReteamSuccess = false;
    };
    /** to edit naac
    * @class DIComponent
    * @method editNaac
    */
    DIComponent.prototype.editNaac = function (data, i) {
        if (this.naacName != null || this.naacLogo != null) {
            this.firstEditNaac = false;
        }
        if (this.firstEditNaac === true) {
            this.firstEditNaac = false;
            this.editNaacData(data);
        }
        else {
            document.getElementById('editN' + i).setAttribute(this.dataToggleConstant, 'modal');
            document.getElementById('editN' + i).setAttribute(this.dataTargetConstant, '#myModal');
            this.method = "editNaacData";
            this.param = data;
            this.msg1 = this.msg2Constant;
        }
    };
    DIComponent.prototype.editNaacData = function (data) {
        this.showReset = true;
        this.naacLog = document.getElementById('filenameNaac');
        this.uploadFileNameNaac = data.logoPath;
        if (this.uploadFileNameNaac != null && this.uploadFileNameNaac !== undefined && this.uploadFileNameNaac.trim() !== "") {
            var b = this.uploadFileNameNaac;
            this.naacLog.innerText = b;
        }
        this.naacName = data.naacAffiliateName;
        this.naacLogo = data.logoPath;
        this.naacLink = data.sharepointLink;
        this.naacId = data.naacAffiliateId;
        this.logoPathImage = '';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.saveNaac = false;
        this.saveAndUpdateNaac = true;
        this.diNaacSuccess = false;
    };
    /** link validation
  * @class DIComponent
  * @method onLinkType
  */
    DIComponent.prototype.onLinkType = function (event, type) {
        var re = /^(https?:\/\/)?(www.\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]?/;
        if (re.test(String(event.target.value).toLowerCase()) === false) {
            if (type === 'news') {
                if (event.target.value !== "") {
                    this.newsLinkValid = true;
                }
            }
            else if (type === 'naac') {
                if (event.target.value !== "") {
                    this.naacLinkValid = true;
                }
                else {
                    this.naacLinkValid = false;
                }
            }
        }
        else if (type === 'news') {
            this.newsLinkValid = false;
        }
        else if (type === 'naac') {
            this.naacLinkValid = false;
        }
    };
    /** email validation
  * @class DIComponent
  * @method onEmailType
  */
    DIComponent.prototype.onEmailType = function (event) {
        var re = new RegExp(/^(?!\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!-)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/);
        if (re.test(String(event.target.value).toLowerCase()) === false) {
            if (this.butDisabled === false) {
                this.reTeamEamilValid = true;
            }
        }
        else {
            this.reTeamEamilValid = false;
        }
    };
    DIComponent.prototype.onFileSelectedNews = function (event) {
        this.isUploadnewsImage = true;
        this.newsFile = event.target.files[0];
        this.selectedFileNameforNews = this.newsFile.name;
        this.newsfileName = this.selectedFileNameforNews;
        this.newsExtensionError = false;
        if (event.target.files[0].type !== "image/png" && (event.target.files[0].type !== this.fileType1Constant)) {
            this.newsExtensionError = true;
        }
    };
    /** checks if word exists in array
   * @class ConfigureGalleryComponent
   * @method isInArray
   */
    DIComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    /** on resource file selected
  * @class DIComponent
  * @method onFileSelected
  */
    DIComponent.prototype.onFileSelected = function (event) {
        this.isFileUploded = true;
        if (event.target.files.length > 0) {
            this.ResourcefileName = event.target.files[0].name;
            this.fileSize = event.target.files[0].size;
            this.fileExtension = this.ResourcefileName.split('.').pop();
            //104857600  524288000
            if (this.fileSize >= 524288000) {
                this.fileSizeExtensionError = true;
            }
            else {
                this.fileSizeExtensionError = false;
                this.selectedFile = event.target.files[0];
                this.UploadDocument = this.selectedFile.name;
            }
        }
    };
    DIComponent.prototype.fileChangeEvent = function (event, imageType) {
        var files = event.target.files;
        var file = files[0];
        this.imageTypeName = imageType;
        if (file.type !== "image/png" && file.type !== this.fileType1Constant) {
            if (this.imageTypeName === 'userPic') {
                this.uploadFileExtensionUser = true;
                this.myInputVariable.nativeElement.value = '';
            }
            else if (this.imageTypeName === 'bannerImage') {
                this.uploadFileExtensionBanner = true;
                this.myInputBannerVariable.nativeElement.value = '';
            }
        }
        else {
            this.imageChangedEvent = event;
            if (this.imageTypeName === 'userPic') {
                this.uploadFileExtensionUser = false;
                this.uploadFileNameUser = file.name;
                document.getElementById("filenameUserPic").textContent = this.uploadFileNameUser;
                this.isLoaderUserPicStop = false;
                this.uploadUserPicImageDone = true;
                this.isUploadUserPicImage = true;
            }
            else if (this.imageTypeName === 'bannerImage') {
                this.uploadFileName = file.name;
                this.uploadFileExtensionBanner = false;
                document.getElementById("filenameBanner").textContent = this.uploadFileName;
                this.isLoaderStop = false;
                this.uploadImageDone = true;
                this.isUploadImage = true;
            }
        }
    };
    DIComponent.prototype.imageCropped = function (event) {
        this.croppedImage = event.base64.replace(/^data:image\/[a-z]+;base64,/, "");
        if (this.imageTypeName === 'userPic') {
            document.getElementById("base64textareaUser").textContent = this.croppedImage;
            this.diUserImage = this.croppedImage;
            this.uploadUserPicImageDone = true;
        }
        else if (this.imageTypeName === 'bannerImage') {
            document.getElementById("base64textarea").textContent = this.croppedImage;
            this.diBannerImage = this.croppedImage;
            this.uploadImageDone = true;
        }
    };
    DIComponent.prototype.imageLoaded = function () {
        if (this.imageTypeName === 'userPic') {
            this.isLoaderUserPicStop = true;
        }
        else if (this.imageTypeName === 'bannerImage') {
            this.isLoaderStop = true;
        }
        else if (this.imageTypeName === 'news') {
            this.isLoadernewsImageStop = true;
        }
        // show cropper
    };
    DIComponent.prototype.cropperReady = function () {
        // cropper ready
    };
    DIComponent.prototype.loadImageFailed = function () {
        // show message
    };
    DIComponent.prototype.cancelUploadedImage = function (imageType) {
        if (imageType === 'userPic') {
            document.getElementById("base64textareaUser").textContent = '';
            document.getElementById("filenameUserPic").textContent = this.fileTypeConstant;
            this.myInputVariable.nativeElement.value = '';
            this.uploadFileExtensionUser = false;
            this.diUserImage = null;
            this.uploadFileNameUser = null;
            this.isUploadUserPicImage = false;
            this.isLoaderUserPicStop = false;
            this.isLoadernewsImageStop = false;
        }
        else if (imageType === 'bannerImage') {
            document.getElementById("base64textarea").textContent = '';
            document.getElementById("filenameBanner").textContent = this.fileTypeConstant;
            this.myInputBannerVariable.nativeElement.value = '';
            this.uploadFileExtensionBanner = false;
            this.diBannerImage = null;
            this.uploadFileName = null;
            this.isUploadImage = false;
            this.isLoaderStop = false;
            this.uploadImageDone = false;
        }
        else if (imageType === 'news') {
            this.isUploadnewsImage = false;
        }
        this.imageChangedEvent = '';
        this.croppedImage = '';
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    };
    DIComponent.prototype.doneUploadedImage = function (imageType) {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        if (imageType === 'userPic') {
            this.myInputVariable.nativeElement.value = '';
            this.uploadFileExtensionUser = false;
            this.uploadUserPicImageDone = false;
            this.isLoaderUserPicStop = false;
            this.isUploadUserPicImage = false;
        }
        else if (imageType === 'bannerImage') {
            this.myInputBannerVariable.nativeElement.value = '';
            this.uploadFileExtensionBanner = false;
            this.isUploadImage = false;
            this.uploadImageDone = true;
            this.isLoaderStop = false;
        }
        else if (imageType === 'news') {
            this.isUploadnewsImage = false;
            this.isLoadernewsImageStop = false;
        }
    };
    DIComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.loginUserId,
            categoryDescription: "D+I Screen"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    return DIComponent;
}());
export { DIComponent };
